import { EvtHeader } from "components/header";
import ProjectForm from "@/modules/work/projects/project/crud/form";
import React from "react";

const CreateProject = () => {
  return (
    <div className="flex-1">
      <EvtHeader title="Create Project" />
      <div className="p-6 max-w-md">
        <ProjectForm />
      </div>
    </div>
  );
};

export default CreateProject;
